/**
 * O HTML de `/` sem cache, para a conferência do build no ar (app/staleBuild.ts; pré-mortem de 25/10, ORD-F-146). Em
 * `src/data`, como todo `fetch` (AC-2.2-01). Nunca lança: null em falha de rede ou resposta não-OK.
 */
export function fetchLivePage(url: string): Promise<string | null> {
  return fetch(url, { cache: 'no-store', credentials: 'omit' }).then(
    (r) => (r.ok ? r.text() : null),
    () => null,
  );
}
